import AutoLoadingButton from "@/components/AutoLoadingButton";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { Alert, Button, Modal } from "antd";
import React from "react";

interface DisclaimerModalProps extends InjectBaseModalProps {
    onConfirm(): Promise<void>;
}

const DisclaimerModal: React.FC<DisclaimerModalProps> = function (props) {
    const { open, onCancel, onConfirm } = props;

    async function handleConfirm() {
        await onConfirm();
        onCancel();
    }

    return (
        <Modal
            width={1050}
            className="instant-ship-disclaimer-modal"
            title="开启极速发货"
            open={open}
            onCancel={onCancel}
            keyboard={false}
            mask={{ closable: false }}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    取消
                </Button>,
                <AutoLoadingButton key="confirm" type="primary" onClick={handleConfirm}>
                    同意免责声明且开启极速发货
                </AutoLoadingButton>,
            ]}
        >
            <Alert
                className="instant-ship-important-tip"
                type="error"
                title={
                    <div>
                        <div>【重要】开启极速发货请注意:</div>

                        <div>
                            <div>
                                1.功能开启后，将自动按您的设置对订单仅取号并发货（处理后会加上“极速发货”标签），后续可搜索该标签相关订单进行处理
                            </div>
                            <div>
                                2.该功能仅对开启后付款的订单生效，建议功能开启期间不要人工操作打单或开启其他软件类似功能避免可能重复操作造成损失
                            </div>

                            <div>
                                3.默认过滤非待发货、已打印、挂起、风控、退款中、代收货款、部分发货、分销代发、异常、锁定、黑名单等订单
                            </div>
                            <div>
                                4.极速发货订单实际未打印快递面单(仅自动取单号)，请及时关注极速发货订单并处理打单拣货发快递等操作
                            </div>
                        </div>
                    </div>
                }
            />

            <div className="instant-ship-disclaimer-title">开启极速发货的免责声明</div>
            <div className="instant-ship-notice-section">
                <p className="mb10">
                    开启极速发货功能，即表示您知悉并同意以下事实,后续如未及时关注订单情况，造成平台处罚、订单异常或资损，发货易不承担法律责任：
                </p>

                <p>
                    1.
                    极速发货”功能为商家打印发货的一项辅助功能，受制于服务器稳定性、授权失效、接口波动等因素，可能存在部分订单打印失败或发货失败的风险。
                </p>
                <p>2. 极速发货无法完全替代手动打印及相关确认操作，您应当在极速发货功能使用时核对订单打印和发货情况。</p>
                <p> 3. 平台对订单发货、揽收时效有考核要求，请您根据您的发货履约时效，谨慎选择是否开启该功能</p>
            </div>
        </Modal>
    );
};

export default DisclaimerModal;
